import createChainedFunction from '@mui/utils/createChainedFunction';
export default createChainedFunction;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/utils/createChainedFunction.js
// module id = 782
// module chunks = 22